const keywords = [
  '群聊撤回现场',
  '办公室小道消息',
  '热搜反转',
  '深夜冲浪',
  '家族群链接',
  '好奇心缺口',
  '社交货币',
  '情绪代偿',
  '围观指南',
  '表情包上新',
];

export default function Ticker() {
  const loop = [...keywords, ...keywords];

  return (
    <div className="w-full bg-accent-500 overflow-hidden py-3">
      <div className="flex w-max marquee-track">
        {loop.map((word, index) => (
          <span
            key={`${word}-${index}`}
            className="flex items-center gap-3 px-6 text-sm text-background-50 whitespace-nowrap"
          >
            <i className="ri-leaf-line" />
            {word}
          </span>
        ))}
      </div>
    </div>
  );
}